import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";
import { useLocation } from "react-router-dom";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//TODO dictamina un acta
export const dictaminarActa = async (payload) => {
  handlerLoading({ loading: true, loadName: "dictaminar" });
  try {
    const response = await axios().post("/registrar_dictamen", payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "dictaminar" });
  }
};

//TODO generar el pago voluntario de un acta
export const generarPago = async (payload) => {
  handlerLoading({ loading: true, loadName: "gemerar_pago" });
  try {
    const response = await axios().post("/generar_pago_dictamen", payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "gemerar_pago" });
  }
};

// marcar_pago_dictamen
export const marcarPagoDictamen = async (payload) => {
  handlerLoading({ loading: true, loadName: "load_pago_dictamen" });
  try {
    const response = await axios().post("/marcar_pago_dictamen", payload);
    const { data, error } = response.data;
    console.log(error);
    
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_pago_dictamen" });
  }
};

